<template>
  <div v-if="finChargement">
    <information-ordre-travail-into-commande v-if="!isDevis"
      :ordreTravails="ordresTravails"
      :afficherLien="afficherLien" :detailCommande="detailCommande">
    </information-ordre-travail-into-commande>
    <div class="card mgt-20px">
      <header class="header-card">
        <p>
          {{$t('editionCommande.logistique.saleProduct')}}
        </p>
      </header>
      <div class="card-content">
        <div v-if="!filteredLignesCommande || filteredLignesCommande.length === 0"
            class="card card-article-any has-background-white mgb-20px">
          <div class="card-content has-text-centered">
            <br>
            <h1 class="title is-size-4">
              {{ this.$t('editionCommande.logistique.anyArticleTitle')}}
            </h1>
            <p>
              {{ this.$t('editionCommande.logistique.anyArticleText')}}
            </p>
          </div>
        </div>
        <div v-else class="columns is-multiline is-vcentered">
          <div class="column is-narrow is-paddingless logistiqueArticle
            logistiqueArticle-checkbox mgb-5" v-if="!isDevis">
              <b-icon></b-icon>
              <b-checkbox :disabled="!afficherLien"  :value="selectAllLine"
                @input="selectAllLigneCommande">
              </b-checkbox>
          </div>
          <selecteur-action v-if="!isDevis"
            class="column is-narrow"
            :disabled="!checkPermissions(permDemande.maj) || !afficherLien"
            @handleAction="handleAction"
            :options='actions'
            :placeholder='$t("general.placeHolder.groupedAction")'
            :titleButton="'general.button.apply'"
            :elementsSelectionnes="hasSelectedLines">
          </selecteur-action>
          <div class="card mgb-20px column is-12 is-paddingless"
              :class="{ 'has-background-table-background': !ligneCommande.id }"
              v-for="ligneCommande in filteredLignesCommande" :key="ligneCommande.ordre">
            <ligneCommandePresse
              :ligneCommande="ligneCommande"
              :readOnly="true"
              v-if="isPresse(ligneCommande)">
            </ligneCommandePresse>
          <ligne-commande
              :ligne="ligneCommande"
              :commande="commande"
              :toutesLignesCommandesIds="getLignesCommandesIds()"
              :etat="commande.etat" :readOnly=true :visu=true :afficherLien="afficherLien"
              :devisCommandeId="commande.id"
              :commercialId="commande.commercialId"
              :assistantId="commande.assistantId"
              :isDevis="isDevis" v-else>
            </ligne-commande>
          </div>
        </div>
      </div>
    </div>
    <b-modal v-model="popUpDisplay" has-modal-card class="modal">
      <creation-demande
        :lignesCommande="selectedLines"
        :devisCommandeIdFromLigne="devisCommandeIdFromLigne"
        :demandeurId="commande.commercialId || commande.assistantId"/>
    </b-modal>
  </div>
</template>

<script>

import { createNamespacedHelpers } from 'vuex';
import informationOrdreTravailIntoCommande
  from '@/components/devisCommandes/editionDevisCommande/informationOrdreTravailIntoCommande';
import * as produitConf from '@/configuration/catalogue/produitConf';
import ligneCommande from '@/components/commande/logistique/ligneCommande';
import selecteurAction from '@/components/general/selecteurAction';
import { ACTION_CREATE_DEMANDE } from '@/configuration/logistique/demande/demandeLogistiqueConf';
import { DEMANDE } from '@/configuration/logistique/permissionsLogistiqueConf';
import ligneCommandePresse from '@/components/commande/logistique/ligneCommandePresse';
import messageErreur from '@/services/general/messageErreur';
import { getAll as getAllDemandeImpression } from '@/api/logistique/demandeImpression';
import { PARAMETRES_INTERNE_KEYS } from '@/store/modules/parametres-mutation-type';
import creationDemande from './p_editionDemande';

const Permissions = createNamespacedHelpers('permissions');
const Parametres = createNamespacedHelpers('parametres');
const Attachments = createNamespacedHelpers('attachments');
const Societe = createNamespacedHelpers('societe');

export default {
  data() {
    return {
      finChargement: false,
      selectAllLine: false,
      popUpDisplay: false,
      actions: [
        { action: ACTION_CREATE_DEMANDE, translation: 'demandeLogistique.creationOrUpdate.action' },
      ],
      permDemande: DEMANDE,
    };
  },
  props: {
    ordresTravails: {
      type: Array,
      required: false,
    },
    detailCommande: {
      type: Object,
      required: false,
    },
    commande: {
      type: Object,
      required: false,
    },
    isDevis: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  components: {
    informationOrdreTravailIntoCommande,
    ligneCommande,
    selecteurAction,
    ligneCommandePresse,
    creationDemande,
  },
  computed: {
    ...Permissions.mapGetters({
      checkPermissions: 'checkPermissions',
    }),
    ...Parametres.mapGetters({
      parametresInterne: 'parametresInterne',
    }),
    ...Societe.mapGetters({
      societeActiveId: 'societeActiveId',
    }),
    filteredLignesCommande() {
      return this.detailCommande.lignesCommande
        .filter(l => !!l.typeProduit);
    },
    hasSelectedLines() {
      return this.filteredLignesCommande.some((ligne) => {
        return ligne.selectedLogistique;
      });
    },
    selectedLines() {
      return this.filteredLignesCommande
        .filter((ligne) => {
          return ligne.typeProduit !== produitConf.CATEGORIE_PRESSE;
        })
        .filter((ligne) => {
          return ligne.selectedLogistique;
        });
    },
    afficherLien() {
      return this.checkIfCurrentSociety(this.commande.societeId);
    },
    devisCommandeIdFromLigne() {
      return this.detailCommande.id ?? this.commande.id;
    },
    moduleDemandeImpression() {
      return this.parametresInterne(PARAMETRES_INTERNE_KEYS.demandeImpression.key);
    },
  },
  methods: {
    ...Attachments.mapActions({
      setAttachmentContext: 'setContext',
    }),
    ...Parametres.mapActions({
      loadParametresInterne: 'loadParametresInterne',
    }),
    selectAllLigneCommande() {
      this.selectAllLine = !this.selectAllLine;
      this.filteredLignesCommande
        .forEach((ligne) => {
          if (ligne.commandeId) return;
          ligne.selectedLogistique = this.selectAllLine;
        });
    },
    isPresse(ligneCommande) {
      return ligneCommande.typeProduit === produitConf.CATEGORIE_PRESSE;
    },
    handleAction(action) {
      switch (action) {
        case ACTION_CREATE_DEMANDE:
          this.popUpDisplay = true;
          break;
        default:
          break;
      }
    },
    getLignesCommandesIds() {
      return this.commande.lignesCommande.filter(ligne => ligne.id)
        .map(ligne => ligne.id);
    },
    async loadDemandesImpresssions() {
      const data = {
        query: {
          ligneCommandeIds: this.getLignesCommandesIds(),
          societeId: this.societeActiveId,
        },
        SkipCount: 0,
      };
      const demandesImpressions = (await getAllDemandeImpression(data)).data.result.items;
      this.detailCommande.lignesCommande.forEach(ligne => {
        ligne.demandesImpressions = demandesImpressions.filter(
          demande => demande.ligneCommandeId === ligne.id);
      });
    },
  },
  async mounted() {
    const loadingComponent = this.$buefy.loading.open();
    try {
      if (this.commande.id) {
        await this.setAttachmentContext({ module: 'LigneCommande' });
      }
      this.detailCommande.lignesCommande.forEach((ligne) => {
        ligne.selectedLogistique = this.selectAllLine;
      });
      await this.loadParametresInterne([
        PARAMETRES_INTERNE_KEYS.demandeImpression.key,
      ]);
      if (this.moduleDemandeImpression) await this.loadDemandesImpresssions();
      this.finChargement = true;
      loadingComponent.close();
    } catch (e) {
      loadingComponent.close();
      messageErreur(this.$i18n);
      throw e;
    }
  },
};

</script>
